<template>
  <div>
    <span v-if="mode !== 'form'" class="has-text-grey">
      {{ setting.label || name }}
    </span>

    <div style="margin-top: 1rem; margin-bottom: 1rem">
      <div v-if="loading" style="padding: 20px; text-align: center">
        Loading departments...
      </div>
      <div v-else>
        <div
          v-for="(filterGroup, index) in localValue"
          :key="`filter-${index}`"
          class="filter-group"
          style="margin-bottom: 15px"
        >
          <div class="filter-group-header">
            <el-input
              v-model="filterGroup.name"
              placeholder="Filter Name"
              style="width: 200px"
              size="small"
            />
            <el-button
              @click="removeFilterGroup(index)"
              type="danger"
              icon="el-icon-delete"
              size="small"
              circle
              style="margin-left: 10px"
            />
          </div>
          <el-select
            v-model="filterGroup.departments"
            multiple
            filterable
            allow-create
            placeholder="Select departments"
            style="width: 100%"
            size="small"
          >
            <el-option
              v-for="dept in departmentOptions"
              :key="dept.id || dept.value"
              :label="dept.label"
              :value="dept.value"
            />
          </el-select>
        </div>

        <el-button
          @click="addFilterGroup"
          type="primary"
          size="small"
          icon="el-icon-plus"
        >
          Add Filter Group
        </el-button>
      </div>
    </div>

    <Tooltip :label="setting.label || name" :content="setting.detail" />
  </div>
</template>

<script>
import Tooltip from "../../Tooltip.vue";
import _ from "lodash";

export default {
  components: { Tooltip },
  props: ["value", "setting", "name", "mode"],
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value[this.name] || [];
      },
      set(newVal) {
        this.$emit("input", { [this.name]: newVal });
      },
    },
    departmentOptions() {
      const departments = this.$store.state.department?.departments || [];
      const defaultDepartment = {
        label: "General",
        value: "00000000-0000-0000-0000-000000000000",
      };

      if (!departments || departments.length === 0) {
        return [defaultDepartment];
      }

      const userDefinedDepartments = _.map(departments, (department) => {
        return {
          label: department.name,
          value: department.name,
          id: department.id,
        };
      });

      return userDefinedDepartments;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.loading = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // Always fetch departments to ensure they're available
    this.$store.dispatch("FETCH_DEPARTMENTS").finally(() => this.loading = false);
  },
  methods: {
    addFilterGroup() {
      const newValue = [...this.localValue];
      newValue.push({
        name: `Filter ${this.localValue.length + 1}`,
        departments: [],
      });
      this.localValue = newValue;
    },
    removeFilterGroup(index) {
      const newValue = [...this.localValue];
      newValue.splice(index, 1);
      this.localValue = newValue;
    },
  },
};
</script>

<style scoped>
.filter-group {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
}

.filter-group-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
